import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import Preloading from "../../../components/basics/Preloading";
import DeleteModal from "../../../components/deleteModal/DeleteModal";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import newLogo from "../../../assets/images/icons/new.png";
import copy from "../../../assets/images/icons/copy.png";
import Paginations from "../../../components/paginaton/Paginations";

const BaseInfoProductCategory = () => {
  const { restaurantId } = useParams();
  const [loading, setLoading] = useState(false);
  const [pricingTypes, setPricingTypes] = useState([]);
  const [selectId, setSelectId] = useState("");
  const [girdData, setGridData] = useState([]);
  const [filterModel, setFilterModel] = useState({
    restaurantId: restaurantId,
    title: "",
    size: 10,
    part: 1,
    total: 0,
    parts: 0,
  });

  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    pricingType: 0,
    description: "",
    restaurantId: restaurantId,
    branchId: null,
  });

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const mapApiToFormModel = (apiData) => ({
    id: apiData.id ?? 0,
    title: apiData.title ?? "",
    pricingType: apiData.pricingType ?? 0,
    description: apiData.description ?? "",
    restaurantId: apiData.restaurantId ?? restaurantId,
  });

  const getGridData = async (customPart = null) => {
    const part = customPart ? customPart : filterModel.part;
    const resp = await apiMethod.getRestaurantProductCategories(
      filterModel.restaurantId,
      filterModel.title,
      filterModel.size,
      part
    );
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      filterModel.part = part;
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
  };

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.getPricingTypes();
    if (!methods.showApiErrors(resp1)) return false;
    setPricingTypes(resp1.data);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [restaurantId]);

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) return false;
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) return false;
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push(".عنوان باید مقدار داشته باشد");
    }
    if (formModel.restaurantId === 0) {
      errors.push(".شناسه شعبه باید مقدار داشته باشد");
    }
    if (formModel.pricingType === 0) {
      errors.push(".نوع قیمت گذاری باید مقدار داشته باشد");
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    setFormModel({
      id: 0,
      title: "",
      pricingType: 0,
      description: "",
      restaurantId: restaurantId,
    });
  };

  const resetFilters = () => {
    setFilterModel({
      restaurantId: restaurantId,
      title: "",
      size: 10,
      part: 1,
      parts: 0,
      total: 0,
    });
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getProductCategoryInfo(id);
    if (!methods.showApiErrors(resp)) return false;
    setFormModel(mapApiToFormModel(resp.data));
    setLoading(false);
  };

  const createNewItem = async () => {
    if (!validForm()) return false;

    setLoading(true);
    const resp = await apiMethod.createRestaurantProductCategory(formModel);
    if (!methods.showApiErrors(resp)) return false;

    await getGridData();
    resetForm();
    setLoading(false);
  };

  const selectItemToDelete = (item) => {
    // setFormModel(mapApiToFormModel(item));
    setSelectId(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeProductCategory(selectId.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const getPricingName = (id) => {
    const item = pricingTypes.find((x) => x.id === id);
    if (item != null || item != undefined) return item.title;
    return "...";
  };

  const searchItem = async () => {
    setLoading(true);
    filterModel.title = document.getElementById("searchInput").value;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const copyItem = (item) => {
    formModel.title = item.title;
    formModel.description = item.description;
    formModel.pricingType = item.pricingType
    setFormModel({ ...formModel });
    const el = document.getElementById("add_item");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      {loading && <Preloading />}
      {/* فرم */}
      <div className="d-none d-lg-block">
        <Link
          to={`/baseinfo/restaurant/${restaurantId}`}
          className="text-start mb-3 link back-link"
        >
          <span>
            <img src={back} className="" alt="return" />
          </span>
          بازگشت
        </Link>
      </div>
      <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
        <Link
          to={`/baseinfo/restaurant/${restaurantId}`}
          className="link back-link"
        >
          <span>
            <img src={back} className="" alt="return" />
          </span>
          طبقات کالا
        </Link>
        <p className="date">{methods.currentDate()}</p>
      </div>
      <div className="saleheader d-none d-lg-block">
        <p>
          طبقات کالا
          <a
            href={`/sale/${restaurantId}/softwareGuide/#section2`}
            className="link rtlicon me-1"
            title="برای اطلاعات بیشتر کلیک کنید"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="bi bi-question-circle"></i>
          </a>
        </p>
      </div>
      <div className="saleheader d-flex flex-column gap-4" id="add_item">
        <div className="d-flex align-items-center gap-4 justify-content-end">
          <button className="btn-action" onClick={resetForm}>
            <img src={newLogo} alt="Image" />
            <span style={{ fontSize: "12px" }}>جدید</span>
          </button>
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <label htmlFor="title" className="form-label required-label fs-14">
              عنوان
            </label>
            <input
              type="text"
              className="form-control input-form"
              id="title"
              value={formModel.title}
              onChange={(e) =>
                setFormModel({ ...formModel, title: e.target.value })
              }
            />
          </div>
          <div className="col-12 col-md-6">
            <label
              htmlFor="pricingType"
              className="form-label required-label fs-14"
            >
              نوع قیمت گذاری
            </label>
            <select
              id="pricingType"
              className="form-select input-form"
              value={formModel.pricingType}
              onChange={(e) =>
                setFormModel({
                  ...formModel,
                  pricingType: parseInt(e.target.value),
                })
              }
            >
              <option value={0}>انتخاب کنید</option>
              {pricingTypes.map((item, index) => (
                <option key={index} value={item.id}>
                  {item.title}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12">
            <label htmlFor="description" className="form-label fs-14">
              توضیحات
            </label>
            <textarea
              className="form-control input-textarea"
              id="description"
              rows={3}
              value={formModel.description}
              onChange={(e) =>
                setFormModel({ ...formModel, description: e.target.value })
              }
            />
          </div>
          <div className="mt-3 gap-3 form-footer">
            <button
              onClick={resetForm}
              type="button"
              className="btn custome-btn btn-outline-purple"
            >
              انصراف
            </button>
            <button
              onClick={createNewItem}
              type="button"
              className="btn custome-btn btn-purple"
            >
              ثبت و ذخیره
            </button>
          </div>
        </div>
      </div>

      {/* جدول */}
      <div className="salemain">
        <span style={{ fontSize: "20px", fontWeight: "bold" }}>طبقات کالا</span>
        <div className="table-responsive warhousetable">
          <table className="table table-md table-custom">
            <thead>
              <tr>
                <th width="100px">ردیف</th>
                <th>عنوان</th>
                <th>نوع قیمت گذاری</th>
                <th>توضیحات</th>
                <th width="100px">عملیات</th>
              </tr>
            </thead>
            <tbody>
              {girdData.map((item, index) => (
                <tr key={item.id}>
                  <td>{(filterModel.part - 1) * filterModel.size + index + 1}</td>
                  <td>{item.title}</td>
                  <td>{getPricingName(item.pricingType)}</td>
                  <td>{item.description}</td>
                  <td className="d-flex align-items-center justify-content-center gap-2">
                    <button
                        className="button-action copy-btn"
                        onClick={() => copyItem(item)}
                      >
                        <img src={copy} alt="Copy" />
                      </button>
                    <button
                      onClick={() => editItem(item.id)}
                      className="btn btn-sm btn-outline-purple me-2"
                    >
                      <i className="bi bi-pencil-square"></i>
                    </button>
                    <button
                      onClick={() => selectItemToDelete(item)}
                      className="btn btn-sm btn-outline-danger"
                    >
                      <i className="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {filterModel.parts > 1 && (
              <div className="pagination justify-content-center mt-5">
                <Paginations
                  total={filterModel.total}
                  size={filterModel.size}
                  onPageChange={callPager}
                />
              </div>
            )}
        </div>
      </div>

      {/* مودال حذف */}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={() => setShowDeleteModal(false)}
          deleteItem={deleteItem}
          text={"طبقه کالا"}
        />
      )}
    </>
  );
};

export default BaseInfoProductCategory;
